import { ListCollection } from '@zag-js/collection';
import { ref } from '@zag-js/core';

const createListCollection = (options) => ref(new ListCollection(options));

export { createListCollection };
